<template>
  <roe-error-message
    class="input-wrap--small"
    :field="design.employer_other_annual_service_reqt_amount"
  >
    <input
      type="number"
      v-model="design.$model.employer_other_annual_service_reqt_amount"
      name="employer_other_annual_service_reqt_amount"
      min="1"
      required
    />
    <label v-if="showMonths" class="input-label-inside">Months</label>
    <label v-if="showHours" class="input-label-inside">Hours</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerOtherServiceReqAppliesInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  computed: {
    showHours() {
      return +this.design.$model.employer_other_annual_service_reqt === 2;
    },
    showMonths() {
      return +this.design.$model.employer_other_annual_service_reqt === 1;
    }
  }
};
</script>
